import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import type { AppsMonitorSummary } from '@internal/plugin-apps-monitor-common';
import { APPS_MONITOR_PLUGIN_ID } from '@internal/plugin-apps-monitor-common';
import { AppsMonitorApi } from './AppsMonitorApi';

export class AppsMonitorClient implements AppsMonitorApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async getSummary(): Promise<AppsMonitorSummary> {
    const baseUrl = await this.discoveryApi.getBaseUrl(APPS_MONITOR_PLUGIN_ID);
    const res = await this.fetchApi.fetch(`${baseUrl}/summary`);
    if (!res.ok) {
      throw new Error(
        `Failed to load apps-monitor summary: ${res.status} ${res.statusText}`,
      );
    }
    return (await res.json()) as AppsMonitorSummary;
  }
}
